import React from 'react';
import { Tabs } from "@shared/ui/tabs";
import { BillsAndService } from '../../../bills/components/tabs/Bills&Service';
import { PaymentHistory } from '../../../bills/components/tabs/PaymentHistory';
import { useTranslation } from 'react-i18next';

import { useCombinedBillsServices } from '../../../bills/hook';
import { getLoginDataFromStorage, getRemoteUtilityId } from '@shared/utils/loginUtils';

interface BillsTabProps {
  consumerNo?: string;
}

export function BillsTab({ consumerNo }: BillsTabProps) {
  const { t } = useTranslation();
  const activeConsumerNo = consumerNo;

  const { data: combinedBillsServicesData } = useCombinedBillsServices({
    remote_utility_id: getRemoteUtilityId(),
    consumer_number: activeConsumerNo,
    is_pagination_required: true,
  });

  return (
    <div className="py-6">
      <Tabs
        defaultValue="bills-services"
        disableUrlSync={true}
        className="w-full"
        tabsListClassName="inline-flex w-auto bg-gray-50 p-1 rounded-lg border border-gray-100"
        tabComponents={{
          "bills-services": {
            label: t("Bills & Services"),
            count: combinedBillsServicesData?.count,
            component: <div className="mt-4"><BillsAndService consumerNo={activeConsumerNo} /></div>
          },
          "payment-history": {
            label: t("Payment History"),
            component: <div className="mt-4"><PaymentHistory /></div>
          }
        }}
      />
    </div>
  );
}
